import React from "react";
import linkedInLogo from "../images/linkedin.svg";
import instagramLogo from "../images/instagram.svg";
import gitHubLogo from "../images/github-logo.svg";

export default class Footer extends React.Component {
    constructor () {
        super();
        this.clickHandler = this.clickHandler.bind(this);
        this.renderFooter = this.renderFooter.bind(this);
        this.determineStickyFooter = this.determineStickyFooter.bind(this);
    }

    clickHandler (e) {
        this.props.handleClick(e.target.id);
    }

    renderFooter = () => {
        if (this.props.isBrowser === 1) {
            return (
                <nav className="navbar navbar-default">
                    <div className="container-fluid">

                        <div className="nav socialMedia">
                            <div className="nav-item socialMedia">
                                <a href="https://www.linkedin.com/in/kent-pham/" target="_blank"><img
                                    src={linkedInLogo} width="30px"></img></a>
                            </div>
                            <div className="nav-item socialMedia">
                                <a href="https://instagram.com/KentPhamStudio" target="_blank"><img src={instagramLogo} width="30px"></img></a>
                            </div>
                            <div className="nav-item socialMedia">
                                <a href="https://github.com/KentPham" target="_blank"><img src={gitHubLogo} width="30px"></img></a>
                            </div>
                        </div>

                        <ul className="nav">
                            <li className="nav-item"><a id="Home" onClick={this.clickHandler}>Home</a></li>
                            <li className="nav-item"><a id="Portfolio" onClick={this.clickHandler}>Portfolio</a></li>
                            <li className="nav-item"><a id="Resume" onClick={this.clickHandler}>Resume</a></li>
                            <li className="nav-item"><a id="Contact" onClick={this.clickHandler}>Contact</a></li>
                        </ul>

                    </div>
                </nav>
            );
        } else {
            return (
                <nav className="navbar navbar-default">
                    <div className="container-fluid">
                        <div className="centering-div">
                            <div className="nav">
                                <div className="nav-item socialMedia nav-one">
                                    <a href="https://www.linkedin.com/in/kent-pham/" target="_blank"><img
                                        src={linkedInLogo} width="30px" alt="Linkedin Logo"></img></a>
                                </div>
                                <div className="nav-item socialMedia">
                                    <a href="https://instagram.com/KentPhamStudio" target="_blank"><img src={instagramLogo} width="30px" alt="Instagram Logo"></img></a>
                                </div>
                                <div className="nav-item socialMedia nav-last">
                                    <a href="https://github.com/KentPham" target="_blank"><img src={gitHubLogo} width="30px" alt="Github Logo"></img></a>
                                </div>
                            </div>
                        </div>
                        <br></br>
                        <br></br>
                        <div className="centering-div">
                            <ul className="nav">
                                <li className="nav-item nav-one"><a id="Home" onClick={this.clickHandler}>Home</a></li>
                                <li className="nav-item"><a id="Portfolio" onClick={this.clickHandler}>Portfolio</a></li>
                                <li className="nav-item"><a id="Resume" onClick={this.clickHandler}>Resume</a></li>
                                <li className="nav-item nav-last"><a id="Contact" onClick={this.clickHandler}>Contact</a></li>
                            </ul>
                        </div>

                    </div>
                </nav>
            );
        }
    }

    determineStickyFooter = (check) => {
        let needSticky = check;
        if (needSticky === 1) {
            return (
                <footer className="fixed-bottom footer">
                    {this.renderFooter()}
                </footer>
            );
        } else {
            return (
                <footer className="footer">
                    {this.renderFooter()}
                </footer>
            );
        }
    }

    render() {
        return this.determineStickyFooter(this.props.needSticky);
    }
}


// WEBPACK FOOTER //
// ./src/components/Footer.js